module.exports = __webpack_public_path__ + "static/media/store-feature-mobile.ce26ea51.png";